module.exports = __webpack_public_path__ + "img/btn-banner-upgrade.202d1687.svg";